import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchRetryBudget } from "./api";
import type { RetryBudgetResponse } from "./api";

// Состояние бюджета повторов организации одним GET.
export function useRetryBudget(): UseQueryResult<RetryBudgetResponse, Error> {
  return useOrgScopedQuery<RetryBudgetResponse>({
    key: ["retryBudget"],
    queryFn: () => fetchRetryBudget(),
    retry: false,
  });
}
